import { render, staticRenderFns } from "./BalanceReport.vue?vue&type=template&id=6f49283f&scoped=true"
import script from "./BalanceReport.vue?vue&type=script&lang=js"
export * from "./BalanceReport.vue?vue&type=script&lang=js"
import style0 from "./BalanceReport.vue?vue&type=style&index=0&id=6f49283f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f49283f",
  null
  
)

export default component.exports